<template>
  <button
    type="button"
    role="menuitem"
    class="flex w-full cursor-pointer gap-x-4 px-6 text-left transition-colors hover:bg-[#787880]/8 active:bg-[#787880]/16 disabled:pointer-events-none disabled:opacity-40"
    :class="description ? 'items-start pt-3 pb-2.5' : 'h-11 items-center'"
    :disabled="disabled"
    @click="emit('select')"
  >
    <component
      :is="icon"
      class="size-5 shrink-0 text-gray-800"
      aria-hidden="true"
    />
    <span class="min-w-0 flex-1">
      <span class="block text-[17px] leading-[18px] font-medium text-gray-800">
        {{ label }}
      </span>
      <span
        v-if="description"
        class="mt-0.5 block text-[13px] leading-[18px] text-gray-500"
      >
        {{ description }}
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  label: string
  description?: string
  disabled?: boolean
}>()

const emit = defineEmits<{ select: [] }>()
</script>
